export class AssignPayrollLiaison {
    associationId: number;
    payrollLiaisonId: number;

    constructor(associationId: number, payrollLiaisonId: number) {
        this.associationId = associationId;
        this.payrollLiaisonId = payrollLiaisonId;
    }
}
